<template>

    <!-- {{ field }} -->

    <RadioButtonGroup
        :name="`${step.name}[${data.element_details.name}]`"
        class="radio--group "
        v-model="field.value"
    >   
        
        <div :class="'radio ' + isSelected(field.value, option.value)" v-for="(option, index) in data.valueOptions">

            <RadioButton
                :inputId="`${step.name}[${data.element_details.name}]` + '-' + option.value"
                :value="option.value"
                @change="onInput"
            />

            
            <label :for="`${step.name}[${data.element_details.name}]` + '-' + option.value">
                {{ option.label }}
            </label>

        </div>

    </RadioButtonGroup>
</template>

<script setup>
const props = defineProps({
    data:Object,
    field:Object,
    step:Object,
})

const emit = defineEmits([
    'update:slideForward','change'
]);

function onInput() {
    emit('change')
    if (!!props.data.jump) {
        emit('update:slideForward');
    }
}

function isSelected(cValue, fValue){
    if(cValue == fValue) return 'is-active';
    return '';

}
</script>